<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import Table from "@/components/standard/PromotionPrevention/components/PromotionTable";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import ItemAPI from "@/services/items/itemsAPI";
import trainingProgramAPI from "../../../services/standards/trainingProgram/trainingProgramAPI";
import DocumentActions from "@/components/document/DocumentActions.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "1.2.1  Programa de capacitación anual",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
    DocumentActions,
  },
  data() {
    return {
      title: "1.2.1  Programa de capacitación anual",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.2.1 Programa Capacitación Promoción y Prevención - P y P",
          active: true,
        },
      ],
      list: [],
      usersList: [],

      item: null,
      itemStatus: "No cumplido",

      itemData: null,
      search: "",

      program: {
        start_date: null,
        end_date: null,
        training_done: null,
        observations: null,
        responsibility: null,
        training_name: null,
      },

      submitted: false,
      loading: true,

      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      planYear: new Date().getFullYear(),
      planWorkflowStatus: "draft",
      planSignedAt: null,

    };
  },
  computed: {
    planYears() {
      const y = new Date().getFullYear();
      return [y + 1, y, y - 1, y - 2];
    },
    planApi() {
      const companyId = this.companyID;
      return {
        pdfUrl: (year) => trainingProgramAPI.planPdfUrl(companyId, year),
        sign: (year, payload) => trainingProgramAPI.planSign(companyId, year, payload),
      };
    },
  },
  validations: {
    program: {
      start_date: {
        required,
      },
      end_date: {
        required,
      },
      training_done: {
        required,
      },
      observations: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(9)
        .then((response) => {
          this.itemData = response;
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * Method to know the status item.
     * @param {Number} - Item ID.
     * @param {Object} - Item to get.
     * @param {Number} -  Status item.
     */
    getStatusItem(id = 9) {
      CompanyItemsAPI.getStatus(this.companyID, id)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 9)
          .then((response) => {
            this.item = response || null;
            this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
          })
          .catch((error) => {
            this.item = null;
            this.itemStatus = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        this.itemStatus = null;
        console.log(error);
      }
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 9,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    fetch() {
      this.$refs.paginator.query();
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    async print() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/PLAN_CAPACITACION_ANUAL.xlsx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async printAsistencia() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/FORMATO_ASISTENCIA_CAPACITACION.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    // Estado de firma del Plan de Capacitación Anual del año seleccionado.
    fetchPlanStatus() {
      if (!this.companyID || !this.planYear) return;
      trainingProgramAPI.planStatus(this.companyID, this.planYear)
        .then((res) => {
          if (!res) return;
          this.planWorkflowStatus = res.workflow_status || "draft";
          this.planSignedAt = res.signed_at || null;
        })
        .catch((e) => console.log("planStatus error", e));
    },

    onPlanSigned(payload) {
      this.planWorkflowStatus = payload.workflow_status;
      this.planSignedAt = payload.signed_at;
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesPromocion(response.id)
            .then((res) => {
              this.usersList = res.employee
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    save() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const data = {
          start_date: this.program.start_date,
          end_date: this.program.end_date,
          training_done: this.program.training_done,
          companies_id: this.companyID,
          observations: this.program.observations,
          responsibility: this.program.responsibility,
          training_name: this.program.training_name,
        };
        trainingProgramAPI.save(data)
          .then((response) => {
            this.sendNotification(26, 9, true);
            const itemChange = {
              companies_id: this.companyID,
              item_id: 9,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              })
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.getUsers();
    this.fetchPlanStatus();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <CheckModal>
                    <p class="text-justify">
                      Es necesario contar con un cronograma mensual de capacitaciones el
                      cual debe estar basado en los peligros que hay en la Empresa, así
                      como los riesgos identificados y descritos en la matriz de riesgos
                      (items: 4.1.1 Metodología para la identificación, evaluación y
                      valoración de peligros y 4.1.2 Identificación de peligros con
                      participación de todos los niveles de la organización).
                    </p>
                    <p class="text-justify">
                      Cuando ingrese personal nuevo, se debe hacer inducción al SG SST, al
                      personal antiguo reinducción y capacitaciones a todos e general en
                      temas específicos del SG SST. El registro de asistencia a estas
                      capacitaciones deberá cargarse en el ítem 1.2.2 Capacitaión,
                      inducción y reinducción al SGSST.
                    </p>
                    <p class="text-justify">
                      Estas capacitaciones se encontrarán enfocadas en la promoción y
                      prevención de la salud, estará dirigida a todos los colaboradores.
                      Podrán realizarse en coordinación con SST, ARL, Caja de compensación
                      u otro tercero. <br />
                      <br />

                      Una vez se cuenta con la programación de las capacitaciones, revisar
                      con el COPASST / Vigía de SST y dejar constancia de esta revisión en
                      el acta de reunión del mes correspondiente.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

                <div class="col-12 text-right m-b-0">
                  <a :href="`/forms/estandares/${companyID}/capacitacion-prevencion`" class="btn btn-primary mx-1">
                    Ver capacitaciones
                  </a>
                  <a :href="`/forms/estandares/${companyID}/cobertura-capacitaciones`" class="btn btn-primary mx-1">
                    <i class="mdi mdi-chart-donut"></i> Informe de cobertura
                  </a>
                  <a @click="printAsistencia" class="btn btn-outline-primary mx-1" style="cursor: pointer;">
                    <i class="bx bx-download"></i> Formato de Asistencia General
                  </a>
                </div>

                <!-- Plan de Capacitación Anual: PDF branded generado desde las capacitaciones del año + firma del encargado -->
                <div class="col-12 mt-3">
                  <div class="card border">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <div class="col-md-7">
                          <h6 class="mb-1">Plan de Capacitación Anual</h6>
                          <p class="text-muted small mb-2">
                            Cronograma generado automáticamente con las capacitaciones registradas del año
                            seleccionado (Planeado según fechas, Ejecutado según actividades), listo para descargar y
                            firmar por el encargado.
                          </p>
                          <b-form-group label="Año" label-for="planYear" class="mb-0" style="max-width: 160px;">
                            <b-form-select id="planYear" v-model="planYear" @change="fetchPlanStatus"
                              class="form-control">
                              <b-form-select-option v-for="y in planYears" :key="y" :value="y">{{ y }}</b-form-select-option>
                            </b-form-select>
                          </b-form-group>
                          <a @click="print" class="small d-inline-block mt-2" style="cursor: pointer;">
                            <i class="bx bx-download"></i> Descargar formato en blanco (Excel)
                          </a>
                        </div>
                        <div class="col-md-5">
                          <DocumentActions
                            :document-id="planYear"
                            :company-id="companyID"
                            :workflow-status="planWorkflowStatus"
                            :signed-at="planSignedAt"
                            :api-service="planApi"
                            document-title="Plan de Capacitación Anual"
                            signer-role="gerente"
                            @signed="onPlanSigned"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12">
                  <b-form-group class="col-md-6 px-2" label="Nombre de la capacitación" label-for="name">
                    <b-form-input type="text" id="name" maxlength="60" v-model="program.training_done" :class="{
                      'is-invalid':
                        submitted &&
                        $v.employeeData.full_name.$error,
                    }">
                    </b-form-input>
                    <div v-if="
                      submitted &&
                      !$v.employeeData.full_name.required
                    " class="invalid-feedback">
                      Este campo es requerido.
                    </div>
                    <div v-if="
                      submitted &&
                      !$v.employeeData.full_name.maxLength
                    " class="invalid-feedback">
                      Máximo 60 caracteres
                    </div>
                  </b-form-group>
                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Responsable(s) de la capacitación">
                    <select :disabled="!getRole('Crear') || !allowAccess()" required class="form-control"
                      v-model="program.responsibility">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                </div>
                <div class="form-row col-12">
                  <b-form-group class="col-md-6 px-2" label="Fecha planificada inicio de capacitación"
                    label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="trainingDate"
                      v-model="program.start_date" :class="{ 'is-invalid': $v.program.start_date.$error && submitted }">
                      >
                    </b-form-input>
                    <div v-if="submitted && $v.program.start_date.$error">
                      <small v-if="!$v.program.start_date.required" class="text-danger">
                        <b>La fecha de inicio de la capacitación es requerida</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha planificada fin de capacitación" label-for="endDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="endDate"
                      v-model="program.end_date" :class="{ 'is-invalid': $v.program.end_date.$error && submitted }">
                      >
                    </b-form-input>
                    <div v-if="submitted && $v.program.end_date.$error">
                      <small v-if="!$v.program.end_date.required" class="text-danger">
                        <b>La fecha final de la capacitación es requerida</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="program.observations" :class="{
                        'is-invalid': $v.program.observations.$error && submitted,
                      }">
                    </b-form-textarea>
                    <div v-if="submitted && $v.program.observations.$error">
                      <small v-if="!$v.program.observations.required" class="text-danger">
                        <b>Las observaciones son requeridas</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button type="submit" :disabled="!allowAccess() || !getRole('Crear')" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
              <hr />

              <Table :companyID="Number(companyID)" />
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
